import { useExclusionRulesStore } from '../../store/exclusionRulesStore';

export const VAULT_STATE_POLL_EXCLUSION_PATTERN = '/api/state';

export function ensureBoothExclusionRules(): void {
  const store = useExclusionRulesStore.getState();
  const existing = store.rules.find(
    (rule) =>
      rule.type === 'exclude' &&
      !rule.isRegex &&
      rule.pattern === VAULT_STATE_POLL_EXCLUSION_PATTERN,
  );

  if (existing) {
    if (!existing.enabled) {
      store.updateRule(existing.id, { enabled: true });
    }
    return;
  }

  store.addRule({
    name: 'Vault state poll',
    description: 'Hide booth vault /api/state polling from HTTP History',
    type: 'exclude',
    pattern: VAULT_STATE_POLL_EXCLUSION_PATTERN,
    isRegex: false,
    enabled: true,
  });
}
